import classNames from 'classnames';
import { FinancialSummary } from '../../../../../../clients/quipli-service/financials/financials';
import { InventoryReturnRequest, Order } from '../../../../../../clients/quipli-service/order/order';
import { CalculateOverageChargeResult } from '../../../../../../clients/quipli-service/product/product';
import { InventoryReturnCalculationsResult } from '../../../inventory-return';
import { FuelCharge } from '../../../shared/types/fuel-charge-types';

export const OffRentGridTotal = ({
  order,
  adHocLineItemsTotal,
  existingSummary,
  waiveLateCharge,
  lateChargeTotal,
  total,
  inventoryReturnRequest,
  fuelCharges,
  hourOverages,
  cycleBillingReturnTotals,
}: {
  order: Order;
  adHocLineItemsTotal: Dinero.Dinero | undefined;
  existingSummary: FinancialSummary | undefined;
  waiveLateCharge: boolean;
  lateChargeTotal: Dinero.Dinero | undefined;
  total: Dinero.Dinero | undefined;
  inventoryReturnRequest: InventoryReturnRequest | undefined;
  fuelCharges: FuelCharge[];
  hourOverages: CalculateOverageChargeResult[];
  cycleBillingReturnTotals: InventoryReturnCalculationsResult;
}) => {
  return (
    <>
      {!order.isCycleBilled && (
        <>
          <div className="flex flex-row items-center gap-2">
            <div>Total</div>
          </div>
          <div></div>
          <div></div>
          <div className="flex flex-row items-center gap-2">
            {adHocLineItemsTotal && existingSummary?.total.add(adHocLineItemsTotal).toFormat()}
          </div>
          <div
            className={classNames('flex flex-row items-center gap-2', {
              'text-[var(--grey-200)]': waiveLateCharge,
            })}
          >
            {lateChargeTotal?.toFormat()}
          </div>
          <div className="flex flex-row items-center gap-2">{total?.toFormat()}</div>
        </>
      )}
      {order.isCycleBilled &&
      inventoryReturnRequest &&
      inventoryReturnRequest.orderProductIds.length > 0 &&
      (fuelCharges.some((fc) => fc.amount > 0) || hourOverages?.some((ov) => ov.overageCharge > 0)) ? (
        <>
          <div className="col-span-3"></div>
          <div>Subtotal</div>
          <div>{cycleBillingReturnTotals.subtotal.toFormat()}</div>
          <div className="col-span-3"></div>
          <div>Tax</div>
          <div>{cycleBillingReturnTotals.tax.toFormat()}</div>
          <div className="col-span-3"></div>
          <div>Total</div>
          <div>{cycleBillingReturnTotals.total.toFormat()}</div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
